import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
	activeTab: "universities",
	isApplicationRequirementsOpen: false,
	isChatbotOpen: false,
};

const commonSlice = createSlice({
	name: "common",
	initialState,
	reducers: {
		setAiCourseFinderTab: (state, action) => {
			state.activeTab = action.payload;
		},
		setApplicationRequirementsOpen: (state, action) => {
			state.isApplicationRequirementsOpen = action.payload;
		},
		setChatbotOpen: (state, action: PayloadAction<boolean>) => {
			state.isChatbotOpen = action.payload;
		},
	},
});

export const {
	setAiCourseFinderTab,
	setApplicationRequirementsOpen,
	setChatbotOpen,
} = commonSlice.actions;

export default commonSlice.reducer;
